import { useFieldArray, useFormContext } from "react-hook-form";
import {
  Adrese,
  DrzavaOperatera,
  Identifikatori,
  NazivOperatera,
  UpravljanjePodacimaElektronickeAdrese,
} from "../../../index";
import { Fragment, useContext } from "react";
import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import Button from "@mui/material/Button";
import axios from "axios";
import { TIP_INFO_PORUKE } from "../../../../enums";
import { Context } from "../../../../context";
import useSWR from "swr";
const fetcher = (url: string) => fetch(url).then((res) => res.json());
const Index: any = () => {
  const { getValues, setValue, reset, setError } = useFormContext();
  const { fields: ostaliOperateri } = useFieldArray({
    name: "ostaliOperateri",
    keyName: "key",
  });
  const odabraniOperater = getValues("odabraniOperater");
  const [{ token }] = useContext(Context);

  if (!ostaliOperateri || ostaliOperateri.length <= 0 || !odabraniOperater)
    return null;

  const obrisiOperatera = async () => {
    try {
      setValue("loading", true);
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/operateri/ostali-operateri/${odabraniOperater}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const { status } = response;
      if (status === 200) {
        setValue("infoPoruka", response.data.message);
        setValue("tipInfoPoruke", TIP_INFO_PORUKE.SUCCESS);
        const ostaliOperateri = await axios.get(
          `${process.env.REACT_APP_API_URL}/operateri/ostali-operateri`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        reset((formValues) => ({
          ...formValues,
          ostaliOperateri: ostaliOperateri.data.ostaliOperateri,
          odabraniOperater: {},
        }));
      }
    } catch (error: any) {
      const { status } = error.response;
      if (status === 400) {
        if (error.response.data.errors) {
          error.response.data.errors.forEach((error: any) =>
            setError(error.fieldName, { message: error.error })
          );
        }
      }
      if (status === 403) {
        if (error.response.data.message) {
          setValue("infoPoruka", error.response.data.message);
          setValue("tipInfoPoruke", TIP_INFO_PORUKE.ERROR);
        }
      }
    } finally {
      setValue("loading", false);
    }
  };

  return ostaliOperateri.map((operater: any, key: number) => {
    if (operater.id !== odabraniOperater) return null;
    return (
      <Card variant={"outlined"} sx={{ mt: 3, position: "relative" }} key={key}>
        <CardHeader
          title={"Uredi operatera"}
          titleTypographyProps={{ variant: "h6" }}
        />
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <NazivOperatera
                nazivPolja={`ostaliOperateri[${key}].naziv.naziv`}
              />
            </Grid>
            <Grid item xs={12}>
              <DrzavaOperatera
                nazivOdjeljka={`ostaliOperateri[${key}].drzava.oznaka`}
                nazivOdjeljkaEuSifra={`ostaliOperateri[${key}].drzava.euSifra`}
              />
            </Grid>
          </Grid>
          <Identifikatori
            nazivPolja={`ostaliOperateri[${key}].identifikatori`}
          />
          <Adrese nazivPolja={`ostaliOperateri[${key}].adrese`} />
          <UpravljanjePodacimaElektronickeAdrese
            nazivPolja={`ostaliOperateri[${key}].elektronickeAdrese`}
          />
          <Grid container justifyContent={"flex-end"} sx={{ mt: 3 }}>
            <Button
              type={"button"}
              variant={"contained"}
              color={"error"}
              sx={{ mr: 1 }}
              onClick={obrisiOperatera}
            >
              Obriši operatera
            </Button>
            <Button variant={"contained"} type={"submit"}>
              Spremi promjene (Save changes)
            </Button>
          </Grid>
        </CardContent>
      </Card>
    );
  });
};

export default Index;
